<template>
  <div>
    <div class="rxWorld">
      <section class="rnOuter ">
        <section class="aoTable">
          <div class="aoTableCell">
            <v-container>
              <v-layout row wrap>
                <v-flex xs4>
                  <v-navigation-drawer permanent>
                    <v-toolbar flat>
                      <v-list>
                        <v-list-tile>
                          <v-list-tile-title class="title">
                            {{ $t('message.backstage.title') }}
                          </v-list-tile-title>
                        </v-list-tile>
                      </v-list>
                    </v-toolbar>
                    <v-divider></v-divider>
                    <v-list dense class="pt-0">
                      <v-list-tile
                        v-for="(item, i) in items"
                        :key="item.title"
                        @click="selectedComponent = i"
                      >
                        <v-list-tile-action>
                          <v-icon>{{ item.icon }}</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                          <v-list-tile-title>{{ $t(item.title) }}</v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                    </v-list>
                  </v-navigation-drawer>
                </v-flex>
                <v-flex xs8>
                  <v-content>
                    <v-container fluid>
                      <component v-bind:is="selectedItem.component" :title="$t(selectedItem.title)"></component>
                    </v-container>
                  </v-content>
                </v-flex>
              </v-layout>
            </v-container>
          </div>
        </section>
        <div class='rnInner'>
          <div class='rnUnit'></div>
          <div class='rnUnit'></div>
          <div class='rnUnit'></div>
          <div class='rnUnit'></div>
          <div class='rnUnit'></div>
          <div class='rnUnit'></div>
          <div class='rnUnit'></div>
          <div class='rnUnit'></div>
          <div class='rnUnit'></div>
          <div class='rnUnit'></div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import Config from '@/modules/backstage/config';
import BasePage from '@/pages/BasePage';

export default {
  name: 'nx-backstage',
  extends: BasePage,
  metaInfo() {
    return {
      title: 'Backstage',
      // all titles will be injected into this template
      titleTemplate: '%s | BCube CMS',
    };
  },
  data() {
    return {
      selectedComponent: 0,
    };
  },
  computed: {
    items() {
      return Config.components;
    },
    selectedItem() {
      return this.items[this.selectedComponent];
    },
  },
  props: {
    title: String,
    icon: String,
  },
  mounted() {
    const stageGizmo = document.querySelector('.rnOuter');
    setTimeout(() => stageGizmo.classList.add('closed'));
    setTimeout(() => stageGizmo.classList.add('finished'), 5750);
  },
};

</script>
<style lang="stylus">
.container {
  max-width: unset;
}

.rnOuter {
  background-position: center;
  background-size: cover;
  background-image: url('https://media-exp1.licdn.com/dms/image/C4D1BAQGlv9Bq-giCkA/company-background_10000/0/1539339877237?e=2147483647&v=beta&t=mD-IwyQ1L053UcSD423kICGyXgNFdOtN7gNUah1HA8s');
  overflow: hidden;
  position: relative;
  height: 100vh;
}

.rnInner {
  width: 100%;
  position: absolute;
  top:-10%; right: 0; bottom: 0; left: 0;
  margin: auto;
  transform-style: preserve-3d;
  transition: transform 6s ease;
  transform-origin: -120% top;

}

.rnUnit {
  width: 10vw;
  height: 120vh;
  background: repeating-linear-gradient(
    to left,
    hsl(360, 80%, 50%) 4vw,
    darken(hsl(360, 80%, 50%), 20%) 8vw,
    lighten(hsl(360, 80%, 50%), 20%) 10vw
  );
  background-size:  100% 100%;
  display:inline-block;
  transform-origin: 0 0%;
  transform: rotate(.5deg);
  animation: rnUnit 2s ease infinite;
}

@keyframes rnUnit {
  50% {
    transform: rotate(-.5deg) ;
  }
}

.rnUnit:nth-child(1) {
  animation-delay: -0.1s;
}
.rnUnit:nth-child(2) {
  animation-delay: -0.2s;
}
.rnUnit:nth-child(3) {
  animation-delay: -0.3s;
}
.rnUnit:nth-child(4) {
  animation-delay: -0.4s;
}
.rnUnit:nth-child(5) {
  animation-delay: -0.5s;
}
.rnUnit:nth-child(6) {
  animation-delay: -0.6s;
}
.rnUnit:nth-child(7) {
  animation-delay: -.7s;
}
.rnUnit:nth-child(8) {
  animation-delay: -.8s;
}
.rnUnit:nth-child(9) {
  animation-delay: -.9s;
}
.rnUnit:nth-child(10) {
  animation-delay: -1s;
}

.aoTable {
  position: absolute;
  z-index: 999;
  display: table;
  width: 100%;
  height: 100vh;
  text-align: center;
}
.aoTableCell {
  color: darken(hsl(360, 80%, 50%), 12%);
  transition: color 3s ease;
}

.rnOuter:not(.closed) .rnInner {
  transform-origin: -120% top;
  transform: scaleX(0);
}

.rnOuter.finished {
  background-image: unset;
  background-color: darken(hsl(360, 80%, 50%), 12%);
}

.rnOuter:not(.closed) .aoTableCell {
  color: white;
}
</style>
